(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const toast = (message) => { const el = $('.toast'); if (!el) return; el.textContent = message; el.hidden = false; clearTimeout(el.timer); el.timer = setTimeout(() => el.hidden = true, 3500); };

  const menuButton = $('[data-menu-toggle]');
  const mobileNav = $('[data-mobile-nav]');
  const closeMenu = () => { mobileNav?.classList.remove('open'); menuButton?.setAttribute('aria-expanded', 'false'); document.body.classList.remove('menu-open'); };
  menuButton?.addEventListener('click', () => { const open = mobileNav.classList.toggle('open'); menuButton.setAttribute('aria-expanded', String(open)); document.body.classList.toggle('menu-open', open); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });

  $$('[data-gallery-thumb]').forEach(button => button.addEventListener('click', () => {
    const gallery = button.closest('[data-product-gallery]');
    const image = $('[data-gallery-main]', gallery);
    image.src = button.dataset.src;
    image.srcset = '';
    image.alt = button.dataset.alt || '';
    $$('[data-gallery-thumb]', gallery).forEach(item => item.setAttribute('aria-current', String(item === button)));
  }));

  $$('[data-product-section]').forEach(section => {
    const form = $('form[action*="/cart/add"]', section);
    const dataNode = $('[data-product-json]', section);
    if (!form || !dataNode) return;
    const product = JSON.parse(dataNode.textContent);
    const idInput = $('[name="id"]', form);
    const price = $('[data-product-price]', section);
    const submit = $('[type="submit"]', form);
    const submitText = $('[data-submit-text]', submit);
    const options = $$('[data-option-position]', form);
    const syncVariant = () => {
      const selected = options.map(group => $('input:checked', group)?.value);
      const variant = product.variants.find(item => item.options.every((value, index) => value === selected[index]));
      if (!variant) return;
      idInput.value = variant.id;
      price.innerHTML = window.Shopify?.formatMoney ? window.Shopify.formatMoney(variant.price, window.themeMoneyFormat) : `$${(variant.price / 100).toFixed(2)}`;
      submit.disabled = !variant.available;
      submitText.textContent = variant.available ? submit.dataset.addText : submit.dataset.soldText;
      history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    };
    options.forEach(group => group.addEventListener('change', syncVariant));
  });

  $$('[data-character-input]').forEach(input => input.addEventListener('input', () => {
    const count = document.getElementById(input.getAttribute('aria-describedby'));
    if (count) count.textContent = `${input.value.length} / ${input.maxLength}`;
  }));

  $$('[data-newsletter-form]').forEach(form => form.addEventListener('submit', () => sessionStorage.setItem('gr-newsletter-submitted', 'true')));
  if (sessionStorage.getItem('gr-newsletter-submitted') && location.hash.includes('contact_form')) { toast('Thank you for joining us.'); sessionStorage.removeItem('gr-newsletter-submitted'); }
})();
